import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';

export interface WaterServiceListItem {
  waterId: number;
  waterTitle: string;
  servicesCount: number;
  updatedAt: Date;
}

export interface WaterService {
  id: number;
  waterId: number;
  waterTitle: string | null;
  image: string | null;
  imageUrl: string | null;
  titleNl: string | null;
  titleEn: string | null;
  titleDe: string | null;
  titleIt: string | null;
  titleFr: string | null;
  unitNl: string | null;
  unitEn: string | null;
  unitDe: string | null;
  unitIt: string | null;
  unitFr: string | null;
  pricePerUnit: number;
  displayOrder: number;
  updatedAt: Date;
}

export interface CreateOrUpdateWaterService {
  id: number;
  image: string | null;
  titleNl: string | null;
  titleEn: string | null;
  titleDe: string | null;
  titleIt: string | null;
  titleFr: string | null;
  unitNl: string | null;
  unitEn: string | null;
  unitDe: string | null;
  unitIt: string | null;
  unitFr: string | null;
  pricePerUnit: number;
  displayOrder: number;
}

export interface WaterServiceGroup {
  waterId: number;
  waterTitle: string;
  updatedAt: Date;
}

export interface TranslateBatchItem {
  title: string;
  unit: string;
  to: string[];
}

export interface TranslateBatchRequest {
  from: string;
  items: TranslateBatchItem[];
}

export interface TranslatedFields {
  title: string;
  unit: string;
}

export interface TranslateBatchItemResult {
  translations: Record<string, TranslatedFields>;
}

export interface TranslateBatchResponse {
  success: boolean;
  items?: TranslateBatchItemResult[];
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class WaterServicesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getAll(): Observable<WaterServiceListItem[]> {
    return this.http.get<WaterServiceListItem[]>(`${this.baseUrl}/api/water-services`);
  }

  getByWater(waterId: number): Observable<WaterService[]> {
    return this.http.get<WaterService[]>(`${this.baseUrl}/api/water-services/by-water/${waterId}/admin`);
  }

  bulkUpdateByWater(waterId: number, services: CreateOrUpdateWaterService[]): Observable<WaterService[]> {
    return this.http.put<WaterService[]>(`${this.baseUrl}/api/water-services/by-water/${waterId}`, services);
  }

  deleteByWater(waterId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/api/water-services/by-water/${waterId}`);
  }

  uploadImage(file: File): Observable<{ filename: string }> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<{ filename: string }>(`${this.baseUrl}/api/water-services/upload-image`, formData);
  }

  translateBatch(request: TranslateBatchRequest): Observable<TranslateBatchResponse> {
    return this.http.post<TranslateBatchResponse>(`${this.baseUrl}/api/water-services/translate-batch`, request);
  }
}
